import React from 'react';
import { Button } from 'react-bootstrap';

const SubscriptionButtons = props => (
  <div className="profile-info-buttons ch-pass">
    {props.subscribed && !props.paymentError ? (
      <div>
        <Button onClick={() => props.handleModalShow('showUnsubscribeModal')} bsStyle="info">
          Unsubscribe
        </Button>

        {props.showPauseSubscriptionButton && (
          <Button onClick={() => props.handleModalShow('showSuspendSubscriptionModal')} bsStyle="info">
            Pause subscription
          </Button>
        )}
      </div>
    ) : (
      <div>
        <Button onClick={props.handleResubscribe} bsStyle="success">
          Resubscribe
        </Button>
      </div>
    )}
  </div>
);

export default SubscriptionButtons;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/SubscriptionButtons.js